import { ENDPOINTS, MIDDLEWARE } from "./api-endpoints";
import { extractBaseServer, extractDomain } from "../utils";

export default async function getChatCount(
  middleware = undefined,
  recruiterId,
  channelId,
  subChannelId,
  corpId
) {
  let url;
  if (typeof window !== "undefined") {
    url = window.location.host;
  }

  try {
    const queryParams = new URLSearchParams({
      platform: "RECRUITER",
      type: "RECRUITER",
      foundItUserId: recruiterId,
      channelId: channelId,
      subChannelId: subChannelId,
      corpId: corpId,
    });

    const response = await fetch(
      `${middleware || MIDDLEWARE}${ENDPOINTS.getChatCount}?${queryParams}`,
      {
        method: "POST",
        headers: {
          baseserver: extractBaseServer(url),
          domain: extractDomain(),
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      if (response.status === 404) {
        console.warn("Chat count endpoint not found (404). Returning default count.");
        return { unreadCount: 0 };
      }
      console.error(`HTTP error! status: ${response.status}`);
      return { error: `HTTP error! status: ${response.status}` };
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching chat count:", error.message);
    return { error: "Network error or unexpected response", details: error.message };
  }
}
